import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderStyleThree from '../../components/Layout/Header/HeaderStyleThree';
import Footer from '../../components/Layout/Footer';
import BackToTop from '../../components/elements/BackToTop';
import SpeakersHero from './SpeakersHero';
import SpeakersGrid from './SpeakersGrid';
import { supabase } from '../../supabaseClient';

// Fallback JSON data in case DB is not populated yet
import fallbackSpeakersData from '../../data/speakers.json';
import fallbackPageData from '../../data/speakers-page.json';

const SpeakersPage = () => {
    const [isVisible, setIsVisible] = useState(false);
    const navigate = useNavigate();
    
    // State for dynamic content
    const [speakers, setSpeakers] = useState([]);
    const [pageContent, setPageContent] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const handleScroll = () => setIsVisible(window.scrollY > 300);
        document.addEventListener('scroll', handleScroll);
        
        fetchData();
        
        return () => document.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    const fetchData = async () => {
        try {
            // Fetch Speakers
            const { data: dbSpeakers, error: spkError } = await supabase
                .from('speakers')
                .select('*');
                
            // Fetch Page Content
            const { data: dbPageContent, error: pageError } = await supabase
                .from('speakers_page_content')
                .select('*')
                .eq('page_name', 'speakers-page')
                .single();
                
            if (!spkError && dbSpeakers) {
                if (dbSpeakers.length === 0) {
                    // If DB query succeeds but returns 0 speakers, they deleted them all. Redirect to home.
                    navigate('/');
                    return;
                }
                setSpeakers(dbSpeakers);
            } else {
                setSpeakers(fallbackSpeakersData.speakers);
            }
            
            if (!pageError && dbPageContent && dbPageContent.data) {
                setPageContent(dbPageContent.data);
            } else {
                setPageContent(fallbackPageData);
            }
        } catch (err) {
            console.error("Error fetching data, using fallback.", err);
            setSpeakers(fallbackSpeakersData.speakers);
            setPageContent(fallbackPageData);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="homestyle2" style={{ background: '#0d0010', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner-border text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="homestyle2">
            <HeaderStyleThree />
            <SpeakersHero heroData={pageContent.hero} />
            <SpeakersGrid speakers={speakers} pageContent={pageContent} tracks={fallbackSpeakersData.tracks} />
            <BackToTop scroll={isVisible} />
            <Footer />
        </div>
    );
};

export default SpeakersPage;
